import { Box } from '@mui/material';

export const LoginImage = ({ src }) => {
  return (
    <Box
      sx={{
        width: '50%',
        height: '100vh',
        position: 'relative',
        display: { xs: 'none', md: 'block' },
      }}
    >
      <img
        src={src}
        alt="Login background"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  );
};
